import type { ReactNode } from "react";
import { Link } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";

export function DashboardLayout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-primary/10 shadow-sm">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
          <div className="flex items-center gap-8">
            <Link to="/home" className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
                <img
                  src="/images/logo-lotwise.jpeg"
                  alt="Lotwise Logo"
                  className="rounded-sm"
                />
              </div>
              <span className="text-xl font-bold text-foreground">Lotwise</span>
            </Link>
            {user?.role === "builder" && (
              <Link
                to="/settings"
                className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors border rounded-lg px-3 py-1.5 align-middle hover:cursor-pointer"
              >
                Settings
              </Link>
            )}
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted-foreground hidden md:block">
              {user?.email}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={logout}
              className="border-primary/20 hover:bg-primary/5 hover:text-primary hover:cursor-pointer"
            >
              Logout
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10">{children}</main>
    </div>
  );
}
